import { render, staticRenderFns } from "./CardDescriptionButton.vue?vue&type=template&id=59d920bc"
import script from "./CardDescriptionButton.vue?vue&type=script&lang=js"
export * from "./CardDescriptionButton.vue?vue&type=script&lang=js"
import style0 from "./CardDescriptionButton.vue?vue&type=style&index=0&id=59d920bc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports